var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sop-container" },
    [
      _c(
        "div",
        { staticClass: "search-container" },
        [
          _c("el-date-picker", {
            staticStyle: { width: "240px", "margin-right": "10px" },
            attrs: {
              size: "mini",
              type: "daterange",
              editable: false,
              "value-format": "yyyy-MM-dd",
              "range-separator": "~",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "picker-options": _vm.pickerOptions,
              clearable: false
            },
            on: { change: _vm.selectTime },
            model: {
              value: _vm.searchSelectTime,
              callback: function($$v) {
                _vm.searchSelectTime = $$v
              },
              expression: "searchSelectTime"
            }
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "180px", "margin-right": "10px" },
              attrs: {
                multiple: "",
                "collapse-tags": "",
                placeholder: "回访类型",
                size: "mini"
              },
              on: { change: _vm.selectType },
              model: {
                value: _vm.selectTypeList,
                callback: function($$v) {
                  _vm.selectTypeList = $$v
                },
                expression: "selectTypeList"
              }
            },
            _vm._l(_vm.typeOptions, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item, value: item }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "140px", "margin-right": "10px" },
              attrs: { clearable: "", placeholder: "回访状态", size: "mini" },
              on: { change: _vm.selectStatus },
              model: {
                value: _vm.getListParams.rviDoStatus,
                callback: function($$v) {
                  _vm.$set(_vm.getListParams, "rviDoStatus", $$v)
                },
                expression: "getListParams.rviDoStatus"
              }
            },
            _vm._l(_vm.statusOptions, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          ),
          _c("el-input", {
            staticStyle: { width: "190px", "margin-right": "10px" },
            attrs: {
              placeholder: "回访计划内容",
              "suffix-icon": "el-icon-search",
              size: "mini",
              clearable: ""
            },
            on: { blur: _vm.searchFn, clear: _vm.searchFn },
            model: {
              value: _vm.getListParams.rviTitle,
              callback: function($$v) {
                _vm.$set(_vm.getListParams, "rviTitle", $$v)
              },
              expression: "getListParams.rviTitle"
            }
          }),
          _c("el-input", {
            staticStyle: { width: "190px", "margin-right": "10px" },
            attrs: {
              placeholder: "客户姓名",
              "suffix-icon": "el-icon-search",
              size: "mini",
              clearable: ""
            },
            on: { blur: _vm.searchFn, clear: _vm.searchFn },
            model: {
              value: _vm.getListParams.ctmKeyWord,
              callback: function($$v) {
                _vm.$set(_vm.getListParams, "ctmKeyWord", $$v)
              },
              expression: "getListParams.ctmKeyWord"
            }
          })
        ],
        1
      ),
      _c("tableWrap", {
        scopedSlots: _vm._u([
          {
            key: "table",
            fn: function() {
              return [
                _c(
                  "el-table",
                  {
                    ref: "returnVisitSOPTable",
                    staticStyle: { width: "100%", "font-size": "13px" },
                    attrs: {
                      size: "medium",
                      "header-cell-style": {
                        background: "#eef1f6",
                        color: "#606266"
                      },
                      height: "calc(100vh - 290px)",
                      "highlight-current-row": true,
                      data: _vm.tableData
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: "序号",
                        width: "50",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rviTitle",
                        label: "回访计划",
                        "min-width": "200",
                        align: "left"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top-start",
                                    title: "回访计划",
                                    width: "200",
                                    trigger: "hover",
                                    "popper-class": "rvi-popover",
                                    content: scope.row.rviTitle
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scope.row.rviTitle) + " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rviType",
                        label: "回访类型",
                        "min-width": "120",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(scope.row.rviType || "--"))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "type",
                        label: "回访方式",
                        "min-width": "120",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  " " + _vm._s(scope.row.typeName || "--") + " "
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rviDoStatus",
                        label: "回访状态",
                        "min-width": "120",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", [
                                scope.row.rviDoStatus == "Y"
                                  ? _c("span", [_vm._v("已回访")])
                                  : scope.row.rviDoStatus == "T"
                                  ? _c("span", [_vm._v("未回访")])
                                  : _c("span", [_vm._v("待回访")])
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ctmKeyWord",
                        label: "回访员工",
                        "min-width": "180",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "center"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ellipsis-6",
                                      attrs: { title: scope.row.rviEmpName }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scope.row.rviEmpName) + " "
                                      )
                                    ]
                                  ),
                                  scope.row.visitUserName &&
                                  scope.row.visitUserName != null
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center"
                                          }
                                        },
                                        [
                                          _vm._v(" ( "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ellipsis-6",
                                              attrs: {
                                                title: scope.row.visitUserName
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.visitUserName
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          scope.row.externalUserIdQy == 2
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color:
                                                      "rgba(255, 92, 0, 0.85)"
                                                  }
                                                },
                                                [_vm._v("@企微")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(70, 189, 10)"
                                                  }
                                                },
                                                [_vm._v("@微信")]
                                              ),
                                          _vm._v(" ) ")
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "kehu",
                        label: "回访客户",
                        "min-width": "250",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "center"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ellipsis-6",
                                      attrs: { title: scope.row.ctmName }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scope.row.ctmName) + " "
                                      )
                                    ]
                                  ),
                                  scope.row.visitCusName &&
                                  scope.row.visitCusName != null
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center"
                                          }
                                        },
                                        [
                                          _vm._v(" ( "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ellipsis-6",
                                              attrs: {
                                                title: scope.row.visitCusName
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.visitCusName
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          scope.row.externalUserIdQy == 2
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color:
                                                      "rgba(255, 92, 0, 0.85)"
                                                  }
                                                },
                                                [_vm._v("@企微")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(70, 189, 10)"
                                                  }
                                                },
                                                [_vm._v("@微信")]
                                              ),
                                          _vm._v(" ) ")
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rviNext",
                        label: "回访日期",
                        "min-width": "180px",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rviTime",
                        label: "实际回访时间",
                        "min-width": "180",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rviInfo",
                        label: "回访情况",
                        "min-width": "250px",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.rviInfo
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "top-start",
                                        title: "回访情况",
                                        width: "350",
                                        trigger: "hover",
                                        "popper-class": "rvi-popover",
                                        content: scope.row.rviInfo
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ellipsis",
                                          attrs: { slot: "reference" },
                                          slot: "reference"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.rviInfo) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c("div", [_vm._v("--")])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createMsg",
                        label: "创建信息",
                        "min-width": "300px",
                        align: "center"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "pagination",
            fn: function() {
              return [
                _c("Pagination", {
                  attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
                  on: { callBack: _vm.callBack }
                })
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }